import { render, staticRenderFns } from "./ShotValLanding.vue?vue&type=template&id=336c932a&"
import script from "./ShotValLanding.vue?vue&type=script&lang=js&"
export * from "./ShotValLanding.vue?vue&type=script&lang=js&"
import style0 from "./ShotValLanding.vue?vue&type=style&index=0&id=336c932a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports